var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headers'),_vm._m(0),_c('footers')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("@/assets/images/shopBj.png")}}),_c('div',{staticClass:"title"},[_vm._v("积分商城")]),_c('div',{staticClass:"title2"},[_vm._v("功能暂未上线，敬请期待")])])
}]

export { render, staticRenderFns }